import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {fetchPrint} from './../actions';
import Loader from 'react-loader';
import {getSortedAnnotations} from '../../annotations/selectors';
import OrderedAnnotations from "../../annotations/components/OrderedAnnotations";
import {FormattedMessage} from 'react-intl';

class PrintContainer extends React.Component {
  constructor(props) {
    super(props);

    this.printShowed = false;
    this.fetchIfNeeded = this.fetchIfNeeded.bind(this);
  }

  componentDidMount() {
    this.printShowed = false;
    this.fetchIfNeeded(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchIfNeeded(nextProps);
  }

  componentDidUpdate() {
    let {print} = this.props;
    if (!print.isFetching && (print.response !== null) && !this.printShowed) {
      window.print();
      this.printShowed = true;
    }
  }

  fetchIfNeeded(props) {
    const {selection, print, fetchPrint} = props;
    if (print.selection !== selection) {
      if (!print.isFetching) {
        fetchPrint(selection);
      }
    }
  }

  render() {
    let {print, printQueue} = this.props;
    printQueue = JSON.parse(JSON.stringify(printQueue));
    let renders = [];
    let itemsById = getItemsById(print.response);
    printQueue.items.forEach((el, index) => {
      if (index > 0) {
        renders.push(<hr key={`hr_${index}`}/>);
      }
      if (itemsById[el.selection[0]] && itemsById[el.selection[0]].type === 'element' && itemsById[el.selection[el.selection.length - 1]] && itemsById[el.selection[el.selection.length - 1]].type === 'annotation') {
        let item = itemsById[el.selection.shift()];
        renders.push(<h2 key={`title_${index}`}>{item.attributes.label}:&nbsp;<FormattedMessage
          id={el.selection.length > 1 ? 'annotations' : 'annotation'}/>&nbsp;
          <small>{item.attributes.label_structure}</small>
        </h2>);
        let annos = el.selection.map(sel => {
          return itemsById[sel];
        });
        let nestedAnnotations = getSortedAnnotations(annos, [item.id], item.attributes.categories);
        renders.push(<OrderedAnnotations key={`${index}-annotations`} annotations={nestedAnnotations} trim={false}/>);
        return;
      }
      if (!itemsById[el.selection[0]] || itemsById[el.selection[0]].type !== 'element') {
        renders.push(<h2 key={`title_${index}`}>{el.label}</h2>);
      }
      el.selection.forEach(sel => {
        let item = itemsById[sel];
        if (!item) {
          renders.push(<p key={`loading_${index}`}>Loading...</p>);
          return;
        }
        let key = '' + item.id + '_' + index;
        switch (item.type) {
          case 'element':
            renders.push(<h2 key={key}>{item.attributes.body}&nbsp;
              <small>{item.attributes.label_structure}</small>
            </h2>);
            break;
          case 'article':
            renders.push(<div key={key} dangerouslySetInnerHTML={{__html: item.attributes.body}}/>);
            if (item.relationships && item.relationships.annotations && item.relationships.annotations.data) {
              let annotations = [];
              item.relationships.annotations.data.forEach(({id}) => {
                if (itemsById[id]) {
                  annotations.push(itemsById[id]);
                }
              });
              let nestedAnnotations = getSortedAnnotations(annotations, item.attributes.elements);
              renders.push(<OrderedAnnotations key={`${key}-annotations`} annotations={nestedAnnotations} trim={false}/>);
            }

            break;
          case 'annotation':
            renders.push(<OrderedAnnotations key={`${index}-annotation`} annotations={getSortedAnnotations([item], [], [])} trim={false}/>);
            break;
          case 'structure':
            renders.push(<h1 key={key}>{item.attributes.label}</h1>);
            item.attributes.flatToc.forEach(el => {
              if (el.type !== 'article') {
                renders.push(<h3 key={key}>{el.label}</h3>);
              }
              else {
                if (itemsById[el.article_id]) {
                  renders.push(<div key={key} dangerouslySetInnerHTML={{__html: itemsById[el.article_id].attributes.body}}></div>);
                }
                else {
                  renders.push(<p key={key}>{el.label}</p>);
                }
              }
            });
        }
      });
    });
    return (
      <div className="print-page">
        <h1><FormattedMessage id="dia"/></h1>
        <hr/>
        <Loader loaded={!print.isFetching && (print.response !== null)}>
          {renders}
        </Loader>
      </div>
    );
  }
}

function getItemsById(response) {
  let items = {};
  if (!response) {
    return items;
  }

  if (response.included) {
    response.included.forEach(el => {
      items[el.id] = el;
    });
  }
  response.data.forEach((item, index) => {
    items[item.id] = item;
  });

  return items;
}

PrintContainer.propTypes = {
  selection: React.PropTypes.string.isRequired,
  print: React.PropTypes.object.isRequired,
  printQueue: React.PropTypes.object.isRequired,
  fetchPrint: React.PropTypes.func.isRequired
};


function mapStateToProps(state, ownProps) {
  let selection = ownProps.location.search;
  let {print, printQueue} = state;
  return {
    selection,
    print,
    printQueue
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchPrint: bindActionCreators(fetchPrint, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrintContainer);



/** WEBPACK FOOTER **
 ** ./src/modules/print/containers/PrintContainer.js
 **/